import Vue from 'vue'
import {
  Badge,
  RadioGroup,
  Cascader,
  ImagePreview,
  Radio,
  Empty,
  SwipeCell,
  Switch,
  Sidebar,
  SidebarItem,
  Tag,
  Uploader,
  Tab,
  Tabs,
  Collapse,
  Skeleton,
  Notify,
  CollapseItem,
  Divider,
  Loading,
  Overlay,
  Form,
  Icon,
  NavBar,
  Popup,
  Picker,
  Toast,
  List,
  ActionSheet,
  Sticky,
  Cell,
  IndexBar,
  IndexAnchor,
  Search,
  Dialog,
  Lazyload,
  Button,
  Col,
  Row,
  Field,
  CellGroup,
  Grid,
  GridItem,
  NoticeBar,
  Image as VanImage,
  Tabbar,
  TabbarItem,
  Panel,
  Swipe,
  SwipeItem,
  SubmitBar,
  Step,
  Steps,
  Card,
  DropdownItem,
  DropdownMenu,
  Checkbox,
  PullRefresh
} from 'vant'

Vue.use(Checkbox)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Badge)
Vue.use(ImagePreview)
Vue.use(Radio)
Vue.use(Cascader)
Vue.use(RadioGroup)
Vue.use(Switch)
Vue.use(SwipeCell)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Tag)
Vue.use(Uploader)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(CollapseItem)
Vue.use(Notify)
Vue.use(Skeleton)
Vue.use(Collapse)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Form)
Vue.use(Icon)
Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Toast)
Vue.use(List)
Vue.use(ActionSheet)
Vue.use(Sticky)
Vue.use(Cell)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Search)
Vue.use(Dialog)
Vue.use(Lazyload)
Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(NoticeBar)
Vue.use(VanImage)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Panel)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(PullRefresh)
Vue.use(Step)
Vue.use(Steps)
Vue.use(SubmitBar)
